export default class {
  hotel = '';
  hotels = [];
  room='';
  hotelRoom = '';
  priceHotel = 0;
  rooms = [];
  constructor(parent) {
    this.parent = parent;
  }

  set(data) {
    const hotelData = data.additionalServicePrices != null ? data.additionalServicePrices.filter(it=>{
      return it.serviceClass.value === 3;
    }).map(item => (
      {
        serviceVariants: this.getCorrectServiceVariants(item.serviceVariants),
        name: this.getCorrectHotelName(item.name),
        id: item.service.value
      }
    )) : [];
    this.hotels = hotelData;
    this.setDefaultHotels();
  }
  getCorrectHotelName(name) {
    return name.split(',')[0];
  }
  setDefaultHotels() {
    if (this.hotels.length) {
      const hotel = this.hotels[0];
      this.changeHotel(hotel.id)
      if (this.rooms.length) {
        const room = this.rooms[0];
        this.changeRoom(room.id)
      }
    }
  }

  getCorrectServiceVariants(serviceVariants) {
    return serviceVariants.filter(x => x.activeQuota > 0)
      .map(it => ({
        activeQuota: it.activeQuota,
        description: it.description + `(квот:  ${it.activeQuota})`,
        isDefault: it.isDefault,
        price: it.price,
        serviceVariantPrice: it.serviceVariantPrice,
      }))
  }
  changeHotel(id) {
    this.hotelRoom = '';
    this.room = '';
    this.priceHotel = 0;
    const hotel = this.hotels.find(it => {
      return it.id === id
    });
    if (hotel == undefined) {
      this.rooms = [];
      return;
    }
    this.hotel = hotel.id;
    this.rooms = hotel.serviceVariants.map(item => ({
      id: item.serviceVariantPrice.value,
      name: item.description,
      price: item.price,
    }))
  }

  changeRoom(id) {
    const room = this.rooms.find(it => {
      return it.id === id
    });
    if (room == undefined) {
      this.priceHotel = 0;
      this.room = '';
      return;
    }
    this.room = room.id;
    this.priceHotel = room.price;
    this.hotelRoom = `${this.hotel}__${this.room}`
  }
}
